import { whiteColor, blackColors } from 'assets/jss/material-dashboard-pro-react';

const paymentMethodTabStyle = (theme) => ({
	smallTab: {
		width: '60%',
		margin: '0 auto',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
	tab: {
		marginTop: '24px',
		minHeight: '640px',
		backgroundColor: whiteColor,
		borderRadius: '8px',
	},
	paymentMethodTitleWrapper: {
		padding: '24px 32px 32px 24px',
	},
	paymentMethodTabContainer: {
		textAlign: 'center',
		margin: '0 auto',
		maxWidth: '320px',
		display: 'flex',
		flexDirection: 'column',
		minHeight: 500,
	},
	masterNumberContainer: {
		textAlign: 'left',
		margin: '0 auto',
		width: '84%',
		display: 'flex',
		flexDirection: 'column',
	},
	paymentMethodInputContainer: {
		width: '100%',
		paddingTop: 10,
	},
	cardInfoContainer: {
		marginLeft: '52px',
		[theme.breakpoints.down('sm')]: {
			marginLeft: '40px',
		},
	},
	creditLimitInfo: {
		display: 'flex',
		'& svg': {
			color: blackColors[3],
		},
	},
	creditLimitInfoText: {
		display: 'inline',
		margin: '0 0 0 10px',
	},
	formButtonContainer: {
		textAlign: 'right',
		paddingTop: 27,
	},
	monthlyBillBlocked: {
		textAlign: 'left',
		paddingBottom: 30,
		'& > p': {
			paddingLeft: 37,
		},
		'& > div': {
			textAlign: 'center',
		},
	},
});

export default paymentMethodTabStyle;
